import { AdminState } from './admin/types';
import { AdministrarState } from './administrar/types';
import { AtendimentoState } from './atendimento/types';
import { UsuarioState } from './usuarios/types';
import { ConsultarUsuariosAcessoState } from './loginUnico/types';
import { EstatisticaState } from './estatistica/types';
import { RelatoriosState } from './relatorios/types';

export enum Types {
	SGU_CLEAR = '@sgu/SGU_CLEAR',
}

export interface SguState {
	admin: AdminState;
	administrar: AdministrarState;
	loginUnico: ConsultarUsuariosAcessoState;
	usuarios: UsuarioState;
	atendimento: AtendimentoState;
	estatistica: EstatisticaState;
	relatorios: RelatoriosState;
}
